// Status-Badge für AssetCard top-left (neben der Auswahl-Checkbox). Approved →
// kein Badge (Default-Zustand). Pure-render.
//
// Redesign S2 (2026-10-10): Wording „Entwurf"/„Archiviert" (Entscheid 6) statt
// DRAFT/ARCHIV; Entwurf = amber-Status-Token statt Markengelb (Gelb gehört nur
// dem Hochladen-CTA), Archiviert = neutral.

import type { AssetStatus } from '../../shared/asset-constants';

const BADGE_CONFIG: Record<
  Exclude<AssetStatus, 'approved'>,
  { cls: string; label: string }
> = {
  draft: { cls: 'bg-warn-100 text-warn-800', label: 'Entwurf' },
  archived: { cls: 'bg-ink-700 text-white', label: 'Archiviert' },
};

type Props = {
  status: AssetStatus;
};

export function StatusBadge({ status }: Props): React.JSX.Element | null {
  if (status === 'approved') return null;
  const cfg = BADGE_CONFIG[status];
  return (
    <span
      className={`absolute top-2.5 left-12 px-2 py-0.5 ${cfg.cls} text-xs font-semibold rounded-full shadow-sm`}
      role="status"
      aria-label={`Status: ${cfg.label}`}
    >
      {cfg.label}
    </span>
  );
}
